<script>
  export default {
    props: {
      info: {
        type: String,
        required: false,
        default: null
      }
    }
  }
</script>


<template>
  <div v-if='info' class='sign_up_campaign' :style='{backgroundColor: teamsiteConfig.color}'>
    <div class='sign_up_campaign__info' v-html='info'></div>
  </div>
</template>


<style lang='scss'>
  .sign_up_campaign {
    position: relative;
    width: rem-calc(130);
    height: rem-calc(130);
    border-radius: 50%;
    transform: rotate(10deg);
    font-size: rem-calc(15);

    &__info {
      color: $white;
      position: absolute;
      top: 50%;
      left: 50%;
      width: rem-calc(110);
      text-align: center;
      transform: translate(-50%, -50%);

      strong {
        white-space: nowrap;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SignUpCampaignBadge.vue